// Chord-relative regions follow the engraving across systems and score widths.
export function rnCadenceRegions(questions = [], anchors = []) {
  const result = [];
  for (const question of questions) {
    const first = anchors.findIndex(a => a.id === question.fromPromptId);
    const last = anchors.findIndex(a => a.id === question.toPromptId);
    if (first < 0 || last < first) continue;
    const systems = new Map();
    for (const anchor of anchors.slice(first, last + 1)) {
      const system = anchor.systemId ?? 0;
      if (!systems.has(system)) systems.set(system, []);
      systems.get(system).push(anchor);
    }
    for (const [system, group] of systems) {
      const hits = group.flatMap(a => a.hits || []);
      if (!hits.length) continue;
      const left = Math.min(...hits.map(h => h.bounds?.left ?? h.x - 8)) - 12;
      const right = Math.max(...hits.map(h => h.bounds?.right ?? h.x + 8)) + 12;
      const top = Math.max(0, Math.min(...hits.map(h => h.bounds?.top ?? h.y - 8)) - 35);
      const bottom = Math.min(
        Math.max(...hits.map(h => h.bounds?.bottom ?? h.y + 8)) + 10,
        Math.min(...group.map(a => a.y)) - 5
      );
      result.push({id:`${question.id}-${system}`,label:question.regionLabel || question.id,
        left,top,width:right-left,height:Math.max(35,bottom-top)});
    }
  }
  return result;
}
